import React from "react";
import classNames from "classnames";

type ButtonVariant =
  | "default"
  | "outline"
  | "danger"
  | "success"
  | "ghost"
  | "outline_base";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  loading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

const ButtonCTA: React.FC<ButtonProps> = ({
  variant = "default",
  loading = false,
  disabled = false,
  children,
  className,
  ...rest
}) => {
  const isDisabled = disabled || loading;

  const baseClasses =
    "inline-flex items-center justify-center px-4 py-2 rounded text-lg w-[150px] h-[48px] font-medium focus:outline-none transition duration-150 ease-in-out";

  const variantClasses = {
    default: "bg-[#044E97] text-white hover:bg-[#033b70]",
    outline:
      "bg-transparent border border-[#044E97] text-[#044E97] hover:bg-[#044E97] hover:text-white",
    outline_base:
      "bg-transparent border border-[#D0D5DD] text-[#344054] hover:bg-gray-200 ",
    danger: "bg-red-600 text-white hover:bg-red-700",
    success: "bg-green-600 text-white hover:bg-green-700",
    ghost: "bg-transparent text-gray-700 hover:bg-gray-100",
  };

  const disabledClasses = "opacity-50 cursor-not-allowed pointer-events-none";

  return (
    <button
      className={classNames(
        baseClasses,
        variantClasses[variant],
        {
          [disabledClasses]: isDisabled,
        },
        className,
      )}
      disabled={isDisabled}
      {...rest}
    >
      {loading ? (
        <svg
          className="animate-spin h-4 w-4 mr-2 text-current"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
          />
        </svg>
      ) : (
        children
      )}
    </button>
  );
};

export default ButtonCTA;
